import { IPortalFolder } from '@interfaces/portal/folders';

interface IFlatFolder {
	folder: IPortalFolder;
	depth: number;
}

export const flattenFolders = (
	folders: IPortalFolder[],
	depth = 0,
): IFlatFolder[] => {
	const result: IFlatFolder[] = [];

	for (const folder of folders) {
		result.push({ folder, depth });

		if (folder.subfolders && folder.subfolders.length > 0) {
			for (const child of flattenFolders(folder.subfolders, depth + 1)) {
				result.push(child);
			}
		}
	}

	return result;
};
